import React, { forwardRef } from 'react';
import InputError from './InputError';
import InputLabel from './InputLabel';

const InputFileUpload = forwardRef(
  (
    {
      type = 'text',
      id,
      placeholder,
      autoComplete,
      required,
      label,
      error,
      value,
      onChange,
      onClick,
    },
    ref,
  ) => {
    return (
      <div className="input-group relative w-full min-w-0">
        <InputLabel title={label} />
        <label
          htmlFor={id}
          className={`peer mt-2 flex items-center justify-between rounded-primary border-width-mini bg-white py-2 px-2 text-base duration-default placeholder:text-sm hover:cursor-pointer hover:border-grey-300 hover:opacity-70 focus:outline-none ${
            error ? 'border-error' : 'border-grey-200'
          }`}
        >
          <p className="overflow-hidden text-base">{placeholder}</p>
          <div className="ml-2 flex h-full min-w-fit items-center justify-center border-l-width-mini border-grey-200 py-3 px-2">
            <svg
              className="ml-1 min-w-[16px]"
              width="16"
              viewBox="0 0 19 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M4.93557 6.08403C5.23803 6.29729 5.69171 6.34747 6.00792 5.97113L8.3451 3.27409V10.8509C8.3451 11.3652 8.78504 11.6287 9.22498 11.6287C9.66491 11.6287 10.1049 11.3652 10.1049 10.8509V3.09847L12.3046 5.83315C12.6483 6.2722 13.2669 6.25965 13.6519 5.99622C13.9681 5.78297 14.133 5.39409 13.8168 5.00522L10.1049 0.401421C9.91238 0.163077 9.58243 0.0125444 9.29372 0H9.27997C9.06 0 8.85378 0.0878108 8.7163 0.250888L4.75684 4.85468C4.38564 5.28119 4.56437 5.80806 4.93557 6.08403Z"
                fill="#1E293B"
              />
              <path
                d="M18.12 8.2417H13.4181C13.1569 8.2417 12.937 8.32951 12.772 8.49259C12.6345 8.64312 12.552 8.83129 12.552 9.04454C12.552 9.44596 12.8407 9.84738 13.4044 9.84738H17.2264V13.4351H1.75976V9.84738H5.48549C6.04917 9.84738 6.33787 9.44596 6.33787 9.04454C6.33787 8.64312 6.04917 8.2417 5.48549 8.2417H0.879878C0.398695 8.2417 0 8.60549 0 9.04454V14.2505C0 14.6895 0.398695 15.0533 0.879878 15.0533H18.12C18.6012 15.0533 18.9999 14.6895 18.9999 14.2505V9.04454C18.9999 8.60549 18.6012 8.2417 18.12 8.2417Z"
                fill="#1E293B"
              />
            </svg>
          </div>
        </label>
        <input
          className="absolute h-0 w-0"
          type={type}
          id={id}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          autoComplete={autoComplete}
          required={required}
          onClick={onClick}
          ref={ref}
        />
        <InputError id={id} error={error} />
      </div>
    );
  },
);

export default InputFileUpload;
